module.exports = __webpack_public_path__ + "images/45f32fe895912f76566f22b62c283270-FTA logo1.png";